import { ISDSIcon } from "@sznds/icons";
import { TActivityMoodType, TActivityType } from "~/interfaces";
import { ACTIVITY_ALPINE_TOURING, ACTIVITY_ALPINIST, ACTIVITY_CANOE, ACTIVITY_CAR, ACTIVITY_CARAVAN, ACTIVITY_CROSS_COUNTRY_SKIS, ACTIVITY_CYCLOTURIST, ACTIVITY_DOWNHILL_SKIS, ACTIVITY_GRAVEL_BIKE, ACTIVITY_HORSE_RIDING, ACTIVITY_INLINE_SKATES, ACTIVITY_KICK_SCOOTER, ACTIVITY_MOTORCYCLE, ACTIVITY_MOUNTAIN_BIKE, ACTIVITY_PADDLEBOARD, ACTIVITY_PARAGLIDE, ACTIVITY_PLANE, ACTIVITY_ROAD_BIKE, ACTIVITY_RUN, ACTIVITY_SNOWSHOES, ACTIVITY_STROLLER, ACTIVITY_TURIST } from "./sds-icons";

export interface IActivityMoodItem {
	type: TActivityMoodType;
	ico: string;
}

/* eslint-disable quote-props */
export const ACTIVITY_TYPE_TO_ICON: {
	[K in TActivityType]: ISDSIcon;
} = {
	"auto_moto": ACTIVITY_CAR,
	"beh": ACTIVITY_RUN,
	"bezky": ACTIVITY_CROSS_COUNTRY_SKIS,
	"gravel": ACTIVITY_GRAVEL_BIKE,
	"horolezectvi": ACTIVITY_ALPINIST,
	"horske_kolo": ACTIVITY_MOUNTAIN_BIKE,
	"inline": ACTIVITY_INLINE_SKATES,
	"jezdectvi": ACTIVITY_HORSE_RIDING,
	"karavan": ACTIVITY_CARAVAN,
	"kocarek": ACTIVITY_STROLLER,
	"kolobezka": ACTIVITY_KICK_SCOOTER,
	"letadlo": ACTIVITY_PLANE,
	"motorka": ACTIVITY_MOTORCYCLE,
	"nakole": ACTIVITY_CYCLOTURIST,
	"paddleboard": ACTIVITY_PADDLEBOARD,
	"paraglide": ACTIVITY_PARAGLIDE,
	"pesky": ACTIVITY_TURIST,
	"silnicni_kolo": ACTIVITY_ROAD_BIKE,
	"sjezd": ACTIVITY_DOWNHILL_SKIS,
	"skialpy": ACTIVITY_ALPINE_TOURING,
	"sneznice": ACTIVITY_SNOWSHOES,
	"vodactvi": ACTIVITY_CANOE,
};
/* eslint-enable quote-props */

export const ACTIVITY_MOODS: Array<IActivityMoodItem> = [{
	type: "smile",
	ico: "emo-great",
}, {
	type: "bored",
	ico: "emo-average",
}, {
	type: "frown",
	ico: "emo-bad",
}];

export const MONTHS_ABBREVIATIONS = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
